import EXTENSION_REGIONS from '@/api/vector/map-vector-layers/extension-regions.json';

export const EXTENSION_REGIONS_MENU_ROUTES = EXTENSION_REGIONS.map((region) => {
  const {id: regionId, region: title, extent, srcIcon} = region;
  const id = 'zoom-region-' + regionId;
  return {
    id,
    title,
    srcIcon,
    data: {extent},
  };
});
